<template>
    <svg
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g>
            <path
                d="M13.93.941h-1.412v1.412a.472.472 0 0 1-.942 0V.94H4.047v1.412a.472.472 0 0 1-.941 0V.94H1.694C.988.941.471 1.553.471 2.353v1.694h15.058V2.353c0-.8-.847-1.412-1.6-1.412M.47 5.035v8.612c0 .847.518 1.412 1.271 1.412h12.236c.752 0 1.6-.612 1.6-1.412V5.035zm4.189 7.906h-1.13a.37.37 0 0 1-.376-.376v-1.177a.37.37 0 0 1 .376-.376h1.177a.37.37 0 0 1 .376.376v1.177c-.047.235-.188.376-.423.376m0-4.235h-1.13a.37.37 0 0 1-.376-.377V7.153c0-.188.141-.377.376-.377h1.177c.188 0 .376.142.376.377v1.176c-.047.236-.188.377-.423.377m3.765 4.235H7.247a.37.37 0 0 1-.376-.376v-1.177a.37.37 0 0 1 .376-.376h1.177a.37.37 0 0 1 .376.376v1.177c0 .235-.141.376-.376.376m0-4.235H7.247a.37.37 0 0 1-.376-.377V7.153a.37.37 0 0 1 .376-.377h1.177c.188 0 .376.142.376.377v1.176c0 .236-.141.377-.376.377m3.764 4.235h-1.176a.37.37 0 0 1-.377-.376v-1.177c0-.188.142-.376.377-.376h1.176a.37.37 0 0 1 .377.376v1.177c0 .235-.141.376-.377.376m0-4.235h-1.176a.37.37 0 0 1-.377-.377V7.153c0-.188.142-.377.377-.377h1.176c.188 0 .377.142.377.377v1.176c0 .236-.141.377-.377.377"
                :fill="customColor"
            />
        </g>
        <defs>
            <clipPath>
                <path
                    fill="#fff"
                    d="M0 0h16v16H0z"
                />
            </clipPath>
        </defs>
    </svg>
</template>
<script setup lang="ts">
    import { DEFAULT_BUTTON_COLOR } from '~/utils/constants';

    defineProps({
        customColor: {
            type: String,
            required: false,
            default: DEFAULT_BUTTON_COLOR
        }
    });
</script>
